import classNames from 'classnames';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var pseudoClassesToInject = []; // Function to call to set which pseudo classes should be added to the class list.

function setPseudoClassInjection(pseudoClasses) {
  pseudoClassesToInject = pseudoClasses;
}
/**
  ## Description
  Build a className string and an inline style object to pass to a react component using the provided keys and props.

  ## Example Usage

```js
  props =  { classes : { button: 'myButtonClass',
                         primary: 'myPrimaryClass',
                         secondary: 'secondaryClass'},
             style: { button: {background:'red'}, primary: {fontFace: 'blah'} } }
  resolve(props, 'button', 'primary')
```

Would return:

```js
{className: 'myButtonClass myPrimaryClass' style: {background: 'red', fontFace: 'blah'}}
```

**/

function resolve(props) {
  var _props$classes = props.classes,
      classes = _props$classes === void 0 ? {} : _props$classes,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;

  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  var classList = keys.map(function (k) {
    if (k && classes.hasOwnProperty(k)) {
      return classes[k];
    }

    return '';
  });
  var styleList = keys.map(function (k) {
    if (k && style.hasOwnProperty(k)) {
      // Because pseudo classes can't be set in inline styles,
      // if the style object has pseudo classes in it, we push them into the classList array,
      // to be added to className eventually.
      // To be on the safe side, we set pseudoClassesToInject to an empty array by default.
      // Consuming applications can opt in and call setPseudoClassInjection
      // to set which pseudo classes they want to add to the classList.
      if (pseudoClassesToInject && pseudoClassesToInject.length) {
        pseudoClassesToInject.forEach(function (pseudoClass) {
          if (style[k][pseudoClass] && typeof style[k][pseudoClass] === 'string') {
            classList.push(style[k][pseudoClass]);
          }
        });
      }

      return style[k];
    }
  });
  return {
    className: classNames(classList),
    style: Object.assign.apply(Object, [{}].concat(_toConsumableArray(styleList)))
  };
}
/**
  ## Description
  Select a subset of values from classes and style in the passed in props object. Useful for styling children objects.


  ## Example Usage for nested classes/style object

```js
  props = { classes: { button: 'myButtonClass',
                       trigger: { button: 'myTriggerButtonClass' } },
            style: { button: { color: 'blue' }, trigger: { button: { color: 'green' } } } }

  select(props, 'trigger')
```

Would return:

```js
{classes: { button: 'myTriggerButtonClass' },
 style: { button: { color: 'green' } } }
```

  ## Example Usage for flat classes/style object

```js
  props = { classes: { button: 'myButtonClass',
                       trigger: 'myTriggerButtonClass' },
            style: { button: { color: 'blue' }, trigger: { color: 'green' } } }

  select(props, 'trigger')
```

Would return:

```js
{classes: { trigger: 'myTriggerButtonClass' },
 style: { trigger: { color: 'green' } } }
```
**/

function select(props) {
  var _props$classes2 = props.classes,
      classes = _props$classes2 === void 0 ? {} : _props$classes2,
      _props$style2 = props.style,
      style = _props$style2 === void 0 ? {} : _props$style2;

  for (var _len2 = arguments.length, keys = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    keys[_key2 - 1] = arguments[_key2];
  }

  var newStyles = keys.map(function (k) {
    if (k && style.hasOwnProperty(k)) {
      if (classes.hasOwnProperty(k) && typeof classes[k] === 'string') {
        return _defineProperty({}, k, style[k]);
      }

      return style[k];
    }
  });
  var newClasses = keys.map(function (k) {
    if (k && classes.hasOwnProperty(k)) {
      if (typeof classes[k] === 'string') {
        return _defineProperty({}, k, classes[k]);
      }

      return classes[k];
    }
  });
  return {
    classes: Object.assign.apply(Object, [{}].concat(_toConsumableArray(newClasses))),
    style: Object.assign.apply(Object, [{}].concat(_toConsumableArray(newStyles)))
  };
}

export { setPseudoClassInjection, resolve, select };
//# sourceMappingURL=index.js.map
